import { useState, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Tokenomics from './pages/Tokenomics';
import Staking from './pages/Staking';
import Vesting from './pages/Vesting';
import Roadmap from './pages/Roadmap';
import DevUpdates from './pages/DevUpdates';
import FWB from './pages/FWB';
import TermsConditions from './pages/Terms';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TokenSale from './pages/TokenSale';
import usePageTransition from './hooks/usePageTransition';
import './styles/App.css';
import './styles/presale-box.css';
import NetworkAlert from './components/NetworkAlert';

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation(); // Obtener la ruta actual
  
  // Usar el hook de transición entre páginas
  usePageTransition();

  // Simular un tiempo de carga inicial
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 800);
    
    return () => clearTimeout(timer);
  }, []);

  const tickerMessages = [
    "1️⃣ ¡Participa en la preventa de eDOP! 🚀 Aprovecha precios exclusivos antes del lanzamiento. 🔥",
    "2️⃣ eDOP revoluciona el mercado! 💎 Únete al ecosistema y asegura tu lugar en la nueva era digital. ⚡",
    "3️⃣ Últimos días de preventa eDOP! ⏳ No te quedes fuera, consigue tus tokens antes de que sea tarde. 🎯"
  ];

  if (isLoading) {
    return (
      <div className="loading-screen">
        <div className="loader"></div>
        <p>Cargando eDOP Token...</p>
      </div>
    );
  }

  return (
    <div className="app">
      <Header />
      <main style={{ minHeight: 'calc(100vh - 120px)' }}> {/* Ajuste de altura */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/tokenomics" element={<Tokenomics />} />
          <Route path="/roadmap" element={<Roadmap />} />
          <Route path="/staking" element={<Staking />} />
          <Route path="/vesting" element={<Vesting />} />
          <Route path="/dev-updates" element={<DevUpdates />} />
          <Route path="/fwb" element={<FWB />} />
          <Route path="/terms" element={<TermsConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/token-sale" element={<TokenSale />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;